export const AUTH_LOGIN = "AUTH/LOGIN";
export const AUTH_LOGIN_GOOGLE = "AUTH/LOGIN_GOOGLE";
